const BASE_API = process.env.VUE_APP_BASE_API;
import 'whatwg-fetch';

export default {
    fetchIncentive(code) {
        const body = {
            code
        };

        return window.fetch(BASE_API + '/external/fetch-incentive', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            cache: 'default',
            body: JSON.stringify(body)
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                const error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then(data => {
            return data;
        });
    },

    sendShippingData(data) {
        return window.fetch(BASE_API + '/external/store-shipping-data', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            cache: 'default',
            body: JSON.stringify(data)
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                const error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then(data => {
            return data;
        });
    },

    postEmailSubscription(email) {
        const body = {
            "email": email,
            "source": "Incentive"
        }
        return window.fetch(BASE_API + '/shop/subscribe', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-mvident': 'www'
            },
            mode: 'cors',
            cache: 'default',
            body: JSON.stringify(body)
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                const error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then(data => {
            return data;
        });
    },
};
